import { Component, OnInit } from '@angular/core';

import { AccommodationsService } from '../accommodations.service';
import { Destination } from '../accommodations.model';

@Component({
	selector: 'app-accommodations-destination-select',
	templateUrl: './accommodations-destination-select.component.html',
	styleUrls: ['./accommodations-destination-select.component.scss'],
})
export class AccommodationsDestinationSelectComponent implements OnInit {
	protected destinations: Destination[] = [];
	protected selected: Destination;

	constructor(public service: AccommodationsService) {}

	ngOnInit(): void {
		this.destinations = [...this.service.data.destinations];
		this.selected = { ...this.service.selected.getValue().destination };
	}

	protected applyfilter(filterValue: string): void {
		this.destinations = this.service.filterBy(this.service.data.destinations, filterValue, 'name');
	}

	protected clear(): void {
		this.selected = null;
	}
}
